<template>
  <v-row class="fill-height">
    <v-col class="text-center">
      <v-chip
        class="px-5 text-h5"
        large
        outlined
        :color="
          breakdown.redoc > 0 ? (breakdown.redoc > 50 ? 'error' : 'success') : 'primary'
        "
      >
        <span>
          {{ 
            breakdown.redoc ? 
            breakdown.redoc.toFixed(1) : 
            'N/A' 
          }}% 
        </span>
      </v-chip>
      <div class="pt-3 text-h6">Redocumentation Rate</div>
    </v-col>
    <v-col class="text-center">
      <v-chip class="px-5 text-h5" large outlined color="primary">
        <span>
          {{ 
            breakdown.totalCond ? 
            breakdown.totalCond.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,').split('.')[0] : 
            'N/A' 
          }}
        </span>
      </v-chip>
      <div class="pt-3 text-h6">Total HCCs</div>
    </v-col>
    <v-col class="text-center">
      <v-chip class="px-5 text-h5" large outlined :color="breakdown.openHcc > 10000 ? 'error' : 'primary'">
        <span>
          {{ 
            breakdown.openCond ? 
            breakdown.openCond.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,').split('.')[0] : 
            'N/A' 
          }}
        </span>
      </v-chip>
      <div class="pt-3 text-h6">Open HCCs</div>
    </v-col>
    <v-col class="text-center">
      <v-chip
        class="px-5 text-h5"
        large
        outlined
        :color="breakdown.newHcc > 0 ? (breakdown.redoc > 1000 ? 'error' : 'success') : 'primary'"
      >
        <span>
          {{
            breakdown.newCond ?
            breakdown.newCond.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,").split(".")[0] : 
            'N/A'
          }}
        </span>
      </v-chip>
      <div class="pt-3 text-h6">New HCCs</div>
    </v-col>
  </v-row>
</template>

<script>

export default {
  components: {},
  props: ['breakdownData'],
  data() {
    return {
      breakdown: []
    };
  },
  methods: {
  },
  watch: {
    breakdownData() {
      this.breakdown = this.breakdownData;
    }
  }
};
</script>

<style scoped>
.sc-card-title {
  background-color: #324152;
  color: #ffffff;
}
</style>
